export default "__VITE_PUBLIC_ASSET__078de2aa__"